var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex",style:(`height: ${_vm.pxToRem(_vm.height)}`)})
}
var staticRenderFns = []

export { render, staticRenderFns }